<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row">
        <div class="col-12 main-content">
          <data-table
            v-model="table"
            :get-page="getPage"
            :per-page="250"
            :selectable-rows="true"
          >
            <template v-slot:head(company)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.company"
                input-type="number"
              />
            </template>
            <template v-slot:head(keywordId)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.keywordId"
                input-type="number"
              />
            </template>
            <template v-slot:head(language)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.language" />
            </template>
            <template v-slot:head(shortDescription)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.shortDescription" />
            </template>
            <template v-slot:head(longDescription)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.longDescription" />
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../../table/data-table';
import { NotificationMixin, ArticleMixin } from '../../../mixins';
import TableFilter from '../../table/table-filter';
import PageHeader from '../../structure/page-header';


export default {
  name: 'ArticleKeywords',
  components: { PageHeader, DataTable, TableFilter },
  mixins: [NotificationMixin, ArticleMixin],
  data: function() {
    return {
      table: {
        selectedRow: null,
        rows: [],
        fields: [
          {key: 'company', label: this.$translate('company')},
          {key: 'keywordId', label: this.$translate('keyword_id')},
          {key: 'language', label: this.$translate('language')},
          {key: 'shortDescription', label: this.$translate('short_description')},
          {key: 'longDescription', label: this.$translate('long_description')},
        ],
        filter: {
          company: null,
          keywordId: null,
          language: null,
          shortDescription: null,
          longDescription: null,
        },
      },
    };
  },
  methods: {
    async getPage(ctx) {
      try {
        const response = await this.articleService.getArticleKeywords(ctx);
        return { totalCount: response.totalCount, data: response.data };
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>
